import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:4000/api/v2';

const OWNER_TOKEN_KEY = 'imperium_owner_token';
const OWNER_MUST_CHANGE_KEY = 'imperium_owner_must_change';

export function getOwnerToken(): string | null {
  try { return localStorage.getItem(OWNER_TOKEN_KEY); } catch { return null; }
}
export function setOwnerToken(token: string) {
  try { localStorage.setItem(OWNER_TOKEN_KEY, token); } catch { /* ignore */ }
}
export function clearOwnerToken() {
  try {
    localStorage.removeItem(OWNER_TOKEN_KEY);
    localStorage.removeItem(OWNER_MUST_CHANGE_KEY);
  } catch { /* ignore */ }
}

export function getOwnerMustChangePassword(): boolean {
  try { return localStorage.getItem(OWNER_MUST_CHANGE_KEY) === '1'; } catch { return false; }
}
export function setOwnerMustChangePassword(must: boolean) {
  try {
    if (must) localStorage.setItem(OWNER_MUST_CHANGE_KEY, '1');
    else localStorage.removeItem(OWNER_MUST_CHANGE_KEY);
  } catch { /* ignore */ }
}

/**
 * API separada para el Portal del Propietario.
 * Usa un JWT independiente del CRM (scope: owner_portal), guardado en localStorage.
 * Si el token es inválido/expira, limpia y deja que la app redirija a /portal/login.
 */
export const ownerBaseApi = createApi({
  reducerPath: 'ownerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = getOwnerToken();
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ['OwnerProperty', 'OwnerActivity', 'OwnerNotes', 'AgentRating'],
  endpoints: () => ({}),
});
